//INITIAL FLOW
import * as types from "./actionTypes";

export const setEmployeesList = (employeesList) => ({
  type: types.SET_EMPLOYEES_LIST,
  payload: {employeesList}
});

export const setAlreadyRegisteredUserInfo = (alreadyRegisteredUserInfo) => ({
  type: types.SET_ALREADY_REGISTERED_USER,
  payload: {alreadyRegisteredUserInfo}
});

export const setLeadCaptureClickCount = (leadCaptureClickCount) => ({
  type: types.SET_LEAD_CAPTURE_CLICK_COUNT,
  payload: {leadCaptureClickCount}
});

export const setUserPopupContent = (userPopupContent) => ({
  type: types.SET_USER_POPUP_CONTENT,
  payload: {userPopupContent}
});

export const setUserTwoFa = (userTwoFa) => ({
  type: types.SET_USER_TWO_FA,
  payload: {userTwoFa}
});

export const setUserOptIn = (optIn) => ({
  type: types.SET_USER_OPT_IN,
  payload: {optIn}
});
